import TableCellClearIcon from '@atlaskit/icon/core/table-cell-clear';
import { Inline } from '@atlaskit/primitives';
import { SHORTCUTS } from '@databases/keyboard-shortcuts';
import React from 'react';
import { useIntl } from 'react-intl-next';

import { ActionComponent } from '../ActionComponent';
import { type UseSelectSelectValuesActionsReturnTypes } from '../actions/build-select-values-actions';
import { messages } from '../messages';

import { DeleteValue } from './DeleteValue';
import { type EditValueProps, EditValues } from './EditValues';

export type SelectValuesActionsProps = {
  actions: UseSelectSelectValuesActionsReturnTypes;
  contentId: string;
  fieldsWithSelectionsCount: number;
  handleDeleteFields: () => void;
  isDeleteColumnsDisabled: boolean;
  isDependencyFieldSelected: boolean;
  selectedEntriesCount: number;
  shouldShowClearCells: boolean;
} & Pick<EditValueProps, 'initialValue' | 'selectedValues'>;

export const SelectValuesActions = ({
  actions,
  contentId,
  fieldsWithSelectionsCount,
  handleDeleteFields,
  initialValue,
  isDeleteColumnsDisabled,
  isDependencyFieldSelected,
  selectedEntriesCount,
  selectedValues,
  shouldShowClearCells,
}: SelectValuesActionsProps) => {
  const { formatMessage } = useIntl();
  const { handleClearFields, handleDeleteEntries } = actions;

  return (
    <Inline
      testId="values-actions-container"
      spread="space-between"
      alignBlock="center"
      space="space.150"
    >
      {fieldsWithSelectionsCount === 1 && !isDependencyFieldSelected && (
        <EditValues
          contentId={contentId}
          handleClearFields={handleClearFields}
          initialValue={initialValue}
          selectedValues={selectedValues}
        />
      )}
      {shouldShowClearCells && (
        <ActionComponent
          type="clear-cells"
          selectionMode="value"
          message={formatMessage(messages['action-bar.clear-values-action'])}
          iconBefore={
            <TableCellClearIcon
              label={formatMessage(messages['action-bar.clear-values-action'])}
              size="medium"
              spacing="spacious"
            />
          }
          onClick={handleClearFields}
          shortcut={SHORTCUTS.CLEAR}
        />
      )}
      <DeleteValue
        handleDeleteEntries={handleDeleteEntries}
        handleDeleteFields={handleDeleteFields}
        entriesCount={selectedEntriesCount}
        fieldsCount={fieldsWithSelectionsCount}
        isDeleteColumnsDisabled={isDeleteColumnsDisabled}
      />
    </Inline>
  );
};
